export function joinPopupPath(parent: string, child: string): string {
  const normalizedParent = parent.replace(/\/+$/, '');
  const normalizedChild = child.replace(/^\/+/, '');

  if (!normalizedParent && !normalizedChild) return '/';
  if (!normalizedParent) return `/${normalizedChild}`;
  if (!normalizedChild) return normalizedParent;

  return `${normalizedParent}/${normalizedChild}`;
}

export function absolutePopupPath(path: string): string {
  return joinPopupPath('', path);
}
